import { FiFacebook, FiTwitter, FiInstagram, FiLinkedin } from "react-icons/fi";
import { BsWhatsapp, BsStar } from "react-icons/bs";
import { FaHome, FaServicestack, FaInfoCircle, FaBriefcase } from "react-icons/fa";
import { AiFillContacts } from "react-icons/ai";
import { bedroomsLeft_Image, bedroomsRight_Image, colorConsultant_Image, commercialSpacesLeft_Image, commercialSpacesRight_Image, commercial_Image, decorativeServices_Image, designConsultation_Image, diningRoomsLeft_Image, diningRoomsRight_Image, dreamHouse_Image, duplex_Image, finalize_Image, hospitality_Image, hyderabad_Image, implementation_Image, interiorDesignConsultant_Image, kakinada_Image, kitchensLeft_Image, kitchensRight_Image, livingRoomLeft_Image, livingRoomRight_Image, medicalspaces_Image, office_spaces_Image, oneBhk_Image, others_Image, personalizeQuote_Image, projectManagement_Image, residential_Image, restaurant_Image, retail_spaces_Image, spaceSaving_Image, threebhk_Image, twoBhk_Image, vijayawada_Image, villa_Image, vizag_Image } from "./imageConstants";

export const SocialIconsData = [
  {
    id: 1,
    name: "Facebook",
    icon: FiFacebook,
    path: '/'
  },
  {
    id: 2,
    name: "Twitter",
    icon: FiTwitter,
    path: '/'
  },
  {
    id: 3,
    name: "Instagram",
    icon: FiInstagram,
    path: 'https://instagram.com/ziva_interiors?igshid=MzRlODBiNWFlZA=='
  },
  {
    id: 4,
    name: "Linkedin",
    icon: FiLinkedin,
    path: '/'
  },
  {
    id: 5,
    name: "Whatsapp",
    icon: BsWhatsapp,
    path: '/'
  },
];

export const HeaderMenuLinks = [
  {
    id: 1,
    name: "Home",
    path: "home",
    icon: FaHome,
    scrollTo: "home_s",
    offsetTop: 0,
  },
  {
    id: 2,
    name: "About",
    path: "about",
    icon: FaInfoCircle,
    scrollTo: "about_s",
    offsetTop: 512,

  },
  {
    id: 3,
    name: "Services",
    path: "services",
    icon: FaServicestack,
    scrollTo: "services_s",
    offsetTop: 0,

  },
  {
    id: 4,
    name: "Portfolio",
    path: "portfolio",
    icon: FaBriefcase,
    scrollTo: "portfolio_s",
    offsetTop: 1372,

  },
  {
    id: 5,
    name: "Contact",
    path: "contact",
    icon: AiFillContacts,
    scrollTo: "contact_s",
    offsetTop: 2410,
  },
];

export const servicesData = [
  {
    id: 1,
    Icon: BsStar,
    isIcon: true,
    name: "INTERIOR DESIGN",
    path: "",
    description:
      "Interior design services offer a vast variety of solutions for our clients’ homes and offices.",
  },
  {
    id: 2,
    Icon: BsStar,
    isIcon: true,
    name: "DECORATIVE SERVICES",
    path: "",
    description:
      "Our professional decorators will be happy to help you change your house’s inner look.",
  },
  {
    id: 3,
    Icon: BsStar,
    isIcon: true,
    name: "SPACE PLANNING",
    path: "",
    description:
      "We create better interior experiences through our space planning services.",
  },
  {
    id: 4,
    Icon: BsStar,
    isIcon: true,
    name: "PROJECT MANAGEMENT",
    path: "",
    description:
      "We provide proper project management as it’s one of the main success factors in interior design.",
  },

];

export const servicesCardData = [
  {
    id: 1,
    title: "Interior Design Consultation",
    description: "Ziva Interiors works with clients to design and create functional and aesthetically pleasing indoor spaces. Our designers will work closely with clients to understand their needs and preferences, and then use their expertise to create a design plan that includes everything from color schemes and furniture layout to lighting and décor.",
    image: interiorDesignConsultant_Image,
  },
  {
    id: 2,
    title: "Decorative Services",
    description: `Our professional decorators will be happy to help you change your house’s inner look.`,
    image: decorativeServices_Image,
  },
  {
    id: 3,
    title: `Project
    Management`,
    description: `Ziva Interiors also offer proper project management as it’s one of the main success factors in interior design, overseeing the implementation of the design plan and working with contractors and other professionals to ensure that the project is completed on time and within budget.`,
    image: projectManagement_Image,
  },
  {
    id: 4,
    title: `Color 
    Consultation`,
    description: `We provide guidance on selecting the right color palette for a room, taking into account factors such as the desired mood, the amount of natural light, and the existing decor.`,
    image: colorConsultant_Image,
  },
  {
    id: 5,
    title: `Space 
    Planning`,
    description: `We analyze the space available and come up with a plan for how to best use it. This includes deciding on the best furniture placement, determining traffic flow, and optimizing space usage.`,
    image: spaceSaving_Image,
  },
  {
    id: 6,
    title: `Furniture 
    Selection`,
    description: `We help clients choose the right furniture pieces for their space, taking into account style, function, and budget.`,
    image: "images/2.jpeg",
  },
  {
    id: 7,
    title: `Lighting 
    Design`,
    description: `We create a lighting plan that not only illuminates the space effectively but also enhances the overall design aesthetic`,
    image: "images/2.jpeg",
  },
  {
    id: 8,
    title: `Material 
    Selection`,
    description: `We assist clients in selecting the right materials for flooring, walls, window treatments, and other elements in the room`,
    image: "images/2.jpeg",
  },

]

export const howItWorksData = [
  {
    id: 1,
    Icon: designConsultation_Image,
    isIcon: false,
    name: `Design Consultation`,
    path: "",
    description:
      "We will respond promptly to schedule a consultation at your convenience to discuss your design needs and bring your vision to life.",
  },
  {
    id: 2,
    Icon: personalizeQuote_Image,
    isIcon: false,
    name: `Get personalized quotes`,
    path: "",
    description:
      `We would be happy to provide you with personalized quotes based on your specific design needs.`,
  },
  {
    id: 3,
    Icon: finalize_Image,
    isIcon: false,
    name: `Finalize the design & Materials`,
    path: "",
    description:
      `Our goal is to ensure that the finalized design and materials reflect your vision, meet your expectations, and create a space that you will love.`,
  },
  {
    id: 4,
    Icon: implementation_Image,
    isIcon: false,
    name: `Implementation & Installation`,
    path: "",
    description:
      `We provide comprehensive assistance and project management to ensure a smooth and successful execution.`,
  },
  {
    id: 5,
    Icon: dreamHouse_Image,
    isIcon: false,
    name: `Move in to live in your dream home`,
    path: "",
    description:
      `Finally, take a moment to celebrate this milestone and enjoy your new dream home.`,
  },
]

export const hoverImageData = [
  {
    id: 1,
    desc: `We believe that your living room is the heart of your home—a space that deserves the perfect blend of style, comfort, and functionality. Our team of skilled designers is passionate about creating captivating living spaces that reflect your personal taste and cater to your lifestyle. Join us as we explore the key elements and innovative ideas that will transform your living room into a haven of beauty and harmony.`,
    leftImage: livingRoomLeft_Image,
    rightImage: livingRoomRight_Image,
    children: [
      {
        original: livingRoomLeft_Image,
        thumbnail: livingRoomLeft_Image,
      },
      {
        original: livingRoomRight_Image,
        thumbnail: livingRoomRight_Image,
      },
    ],
    title: "Living Rooms"
  },
  {
    id: 2,
    desc: `At Ziva Interiors, we understand the importance of creating memorable dining experiences.
    By combining your vision with our expertise, we will curate an interior design concept that surpasses your expectations, ensuring that your dining room becomes a cherished centerpiece of your home and leave a lasting impression on your guests.`,
    leftImage: diningRoomsLeft_Image,
    rightImage: diningRoomsRight_Image,
    children: [
      {
        original: diningRoomsLeft_Image,
        thumbnail: diningRoomsLeft_Image,
      },
      {
        original: diningRoomsRight_Image,
        thumbnail: diningRoomsRight_Image,
      },
    ],
    title: "Dining Rooms"
  },
  {
    id: 3,
    desc: `We believe that every kitchen should be a reflection of your unique taste, lifestyle, and culinary aspirations. Our team of expert designers is thrilled to present a transformative vision for your kitchen that harmonizes style, functionality, and practicality. Get ready to embark on an exciting design journey with us as we transform your kitchen into a culinary haven. Contact us today to begin this culinary adventure together.`,
    leftImage: kitchensLeft_Image,
    rightImage: kitchensRight_Image,
    children: [
      {
        original: kitchensLeft_Image,
        thumbnail: kitchensLeft_Image,
      },
      {
        original: kitchensRight_Image,
        thumbnail: kitchensRight_Image,
      },
    ],
    title: "Kitchens"
  },
  {
    id: 4,
    desc: `We understand the importance of a well-designed bedroom that promotes relaxation and rejuvenation Colors play a vital role in setting the mood and ambiance of a bedroom. We will carefully select a color palette that promotes relaxation and tranquility, taking into consideration factors such as natural light, room size, and your personal preferences. Get ready to experience restful nights and wake up refreshed in a space that feels like a dream come true.`,
    leftImage: bedroomsLeft_Image,
    rightImage: bedroomsRight_Image,
    children: [
      {
        original: bedroomsLeft_Image,
        thumbnail: bedroomsLeft_Image,
      },
      {
        original: bedroomsRight_Image,
        thumbnail: bedroomsRight_Image,
      },
    ],
    title: "Bedrooms"
  },
  {
    id: 5,
    desc: `Whether it's an office, retail store, or hospitality establishment, the interior design of commercial spaces has a significant impact on the experiences of employees, customers, and guests. Our expert design team is thrilled to present a transformative vision for your commercial space, creating an environment that inspires and leaves a lasting impression.`,
    leftImage: commercialSpacesLeft_Image,
    rightImage: commercialSpacesRight_Image,
    children: [
      {
        original: commercialSpacesLeft_Image,
        thumbnail: commercialSpacesLeft_Image,
      },
      {
        original: commercialSpacesRight_Image,
        thumbnail: commercialSpacesRight_Image,
      },
    ],
    title: "Commercial Spaces"
  }
]

export const contactPopupData =
{
  id: 1,
  typeOfProjectTitle: "Tell us about your project",
  typeOfProject: [
    {
      id: "Residential",
      name: "Residential",
      Residential: "From floor to ceiling, we'll make your home appealing!",
      Residential_Image: residential_Image,
      aboutYourPlace: [
        {
          id: "1bhk",
          name: "1 BHK",
          description: "1 BHK, where big dreams begin to play",
          image: oneBhk_Image
        },
        {
          id: "2bhk",
          name: "2 BHK",
          description: "2 BHK, Double the rooms, Double the happiness",
          image: twoBhk_Image
        },
        {
          id: "3bhk",
          name: "3 BHK",
          description: "3 BHK, With room for everyone, dreams and families both grow",
          image: threebhk_Image
        },
        {
          id: "4bhk",
          name: "4 BHK/Duplex",
          description: "Duplex, A touch of luxury, where style & comfort blend in harmony",
          image: duplex_Image
        },
        {
          id: "Villa",
          name: "Independent House/Villa",
          description: "Villa living, a life of pure delight, a place where luxury & comfort coexist.",
          image: villa_Image
        },

      ]
    },
    {
      id: "Commercial",
      name: "Commercial",
      Commercial: "You are at the right place, we specialize in commercial spaces",
      Commercial_Image: commercial_Image,
      aboutYourPlace: [
        {
          id: "retail",
          name: "Retail Spaces",
          description: "Retail Spaces, A shopping destination with shelves filled with wonders",
          image: retail_spaces_Image
        },
        {
          id: "Office",
          name: "Office Spaces",
          description: "Office Spaces, A space for creativity to shine through, where ideas ignite & dreams thrive,",
          image: office_spaces_Image
        },
        {
          id: "Hospitality",
          name: "Hospitality Spaces",
          description: "Hospitality Spaces, A home away from home, with exquisite amenities & a welcoming embrace.",
          image: hospitality_Image
        },
        {
          id: "Medical",
          name: "Medical Spaces",
          description: "Medical Spaces, A place of  care & compassion, where healing begins and hope always wins.",
          image: medicalspaces_Image
        },
        {
          id: "Restaurant",
          name: "Restaurant/Cafe",
          description: "Restaurant/Cafe , From Cozy corners to Outdoor patio views, where memories are created forever.",
          image: restaurant_Image
        }
      ]
    }
  ],
  areaTitle: "Which area do you need",
  area: [
    {
      id: 'vizag',
      name: 'Vizag',
      description: "Vizag, The City of Destiny It is our hometown too",
      image: vizag_Image
    },
    {
      id: 'hyderabad',
      name: 'Hyderabad',
      description: "Hyderabad, From technology to biryani, Zivafied.",
      image: hyderabad_Image
    },
    // {
    //   id: 'vijayawada',
    //   name: 'Vijayawada',
    //   description: "From the hill top's  Kanaka Druga's shrine to River Krishna's graceful flow, Vijayawada's is so divine.",
    //   image: vijayawada_Image
    // },
    // {
    //   id: 'kakinada',
    //   name: 'Kakinada',
    //   description: "From Uppada To Coringa Kakinada's beauty shines so bright",
    //   image: kakinada_Image
    // },
    // {
    //   id: 'others',
    //   name: 'Others',
    //   description: false,
    // },
  ]
}
